import Choices from 'choices.js';

function initFrontendScripts() {
    updateHeaderOffsetSpacing();
    toggleMobileMenu();
    toggleMobileSubmenus();
    toggleSearchNav();
    centerActivitiesNavOnCurrent();
    logHorizontalOverflow();
    choicesSelectors();
    displayerButtons();
    dropdownsToggler();
    columnsSwiperForMobile();
    discographySwiper();
    videosSwiper();
    galerySwiper();
    photoCtaSwiper();
    ageGroupSwiper();
}

function updateHeaderOffsetSpacing() {
    const header = document.querySelector('header.site-header');
    if (!header) {
        return;
    }

    const headerBounds = header.getBoundingClientRect();
    const headerOffset = Math.max(0, headerBounds.top);
    const siteMainOffset = Math.ceil(headerBounds.height + headerOffset);
    document.documentElement.style.setProperty('--hk-site-header-height', `${siteMainOffset}px`);

    if (window.ResizeObserver && !header.dataset.hkHeaderResizeObserverAttached) {
        header.dataset.hkHeaderResizeObserverAttached = '1';
        const ro = new ResizeObserver(updateHeaderOffsetSpacing);
        ro.observe(header);
    }
}

function toggleMobileSubmenus() {
    const SUBMENU_ITEMS = document.querySelectorAll('#mobile-nav .menu-item-has-children');

    SUBMENU_ITEMS.forEach(item => {
        const link = item.querySelector('a');

        if (link) {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                item.classList.toggle('open');
            });
        }
    });
}

function toggleMobileMenu() {

    const HAMBURGUER_ICON = document.querySelector('.site-header #hamburguer-icon')
    const CLOSE_ICON = document.querySelector( 'nav#mobile-nav .close-btn')
    const MOBILE_MENU = document.querySelector('nav#mobile-nav')

    if (!HAMBURGUER_ICON || !CLOSE_ICON || !MOBILE_MENU) {
        return;
    }

    HAMBURGUER_ICON.addEventListener( 'click', ( e ) => {
        MOBILE_MENU.classList.add( 'open' )
        document.body.classList.add('mobile-open')
    })

    CLOSE_ICON.addEventListener( 'click', ( e ) => {
        MOBILE_MENU.classList.remove( 'open' )
        document.body.classList.remove('mobile-open')
    })
}

function toggleSearchNav() {
    const SEARCH_ICON = document.querySelector('.site-header .search-btn')
    const SEARCH_NAV = document.querySelector('.site-header #search-nav');
    if (!SEARCH_ICON || !SEARCH_NAV) {
        return;
    }
    const CLOSE_NAV = SEARCH_NAV.querySelector('.search-controls .close-search')
    if (!CLOSE_NAV) {
        return;
    }

    SEARCH_ICON.addEventListener( 'click', (e) => {
        e.preventDefault() 
        SEARCH_NAV.classList.toggle('open')
    })

    CLOSE_NAV.addEventListener( 'click', ( e ) => {
        e.preventDefault()
        SEARCH_NAV.classList.remove('open')
    })
}

function logHorizontalOverflow() {
    if (!window.matchMedia('(max-width: 1023px)').matches) {
        return;
    }

    const viewportWidth = document.documentElement.clientWidth;
    const offenders = Array.from(document.querySelectorAll('body *'))
        .filter((el) => el.scrollWidth > viewportWidth);

    if (offenders.length === 0) {
        return;
    }

    console.warn('[debug] Elementos con overflow horizontal:', offenders);
}

function centerActivitiesNavOnCurrent() {
    if (!window.matchMedia('(max-width: 1192px)').matches) {
        return;
    }

    const nav = document.querySelector('#activities-nav');
    if (!nav) {
        return;
    }

    const currentItem = nav.querySelector('.current-menu-item');
    if (!currentItem) {
        return;
    }

    currentItem.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
    });
}

function choicesSelectors() {

    const choicesSelects = document.querySelectorAll('.choices-select')
    choicesSelects.forEach( ( select ) => {
        new Choices( select, {
            removeItemButton: true,
            itemSelectText: '',
            placeholder: false,
            placeholderValue: 'Selecciona una opción'
        })
    })
}

function displayerButtons() {
    const displayerButtons = document.querySelectorAll('.displayer-btn')
    displayerButtons.forEach( ( button ) => {
        button.addEventListener( 'click', ( e ) => {
            e.preventDefault()
            let displayId = button.dataset.display
            let displayEl = document.getElementById( displayId )
            button.classList.toggle('open')
            if( button.classList.contains('open') ) {
                displayEl.style.visibility = 'visible'
                displayEl.style.height = 'inherit'
            } else {
                displayEl.style.visibility = 'hidden'
                displayEl.style.height = '0px'
            }
        })
    } )
}

function dropdownsToggler() {
    const DROPDOWNS = document.querySelectorAll( '.wp-block-hakuna-blocks-dropdown .dropdown-header' )

	DROPDOWNS.forEach( ( dropdown ) => {
        if (!dropdown.dataset.listenerAdded) { 
            dropdown.addEventListener( 'click', () => {
                dropdown.parentNode.classList.toggle( 'opened' )
            })
            dropdown.dataset.listenerAdded = "true";
        }
	})
}

function columnsSwiperForMobile() {
    if (window.innerWidth <= 768) {
        const columnBlocks = document.querySelectorAll(".wp-block-columns.is-style-slider-mobile");
    
        columnBlocks.forEach((block, index) => {
            const columns = block.querySelectorAll(".wp-block-column");
    
            const swiperWrapper = document.createElement("div");
            swiperWrapper.classList.add("swiper-wrapper");
    
            columns.forEach((column) => {
                column.classList.add("swiper-slide");
                swiperWrapper.appendChild(column);
            });
    
            const swiperContainer = document.createElement("div");
            swiperContainer.classList.add("swiper", "columns-slider");
    
            swiperContainer.appendChild(swiperWrapper);
    
            const pagination = document.createElement("div");
            const paginationClass = `swiper-pagination-columns-${index}`;
            pagination.classList.add(paginationClass);
    
            block.innerHTML = "";
            block.appendChild(swiperContainer);
            block.appendChild(pagination);
    
            new Swiper(swiperContainer, {
                slidesPerView: 1,
                spaceBetween: 20,
                loop: false,
                pagination: {
                    el: `.${paginationClass}`,
                    clickable: true
}
            });
        });
    }
};
  
function discographySwiper() {
    const discographyBlocks = document.querySelectorAll(".wp-block-columns.is-style-discography-slider");

    discographyBlocks.forEach((block, index) => {
        const columns = block.querySelectorAll(".wp-block-column");

        const swiperWrapper = document.createElement("div");
        swiperWrapper.classList.add("swiper-wrapper");

        columns.forEach((column) => {
            column.classList.add("swiper-slide");
            swiperWrapper.appendChild(column);
        });

        const swiperContainer = document.createElement("div");
        swiperContainer.classList.add("swiper", "discography-slider-container");

        swiperContainer.appendChild(swiperWrapper);

        const pagination = document.createElement("div");
        const paginationClass = `swiper-pagination-discography-${index}`;
        pagination.classList.add(paginationClass);

        block.innerHTML = "";
        block.appendChild(swiperContainer);
        block.appendChild(pagination);

        new Swiper(swiperContainer, {
            slidesPerView: 1,
            spaceBetween: 32,
            loop: false,
            pagination: {
                el: `.${paginationClass}`,
                clickable: true
            },
            breakpoints: {
                768: {
                    slidesPerView: 4,
}
            }
        });
    });
};

function videosSwiper() {
    const videosBlocks = document.querySelectorAll(".wp-block-columns.is-style-videos-slider");

    videosBlocks.forEach((block, index) => {
        const columns = block.querySelectorAll(".wp-block-column");

        const swiperWrapper = document.createElement("div");
        swiperWrapper.classList.add("swiper-wrapper");

        columns.forEach((column) => {
            column.classList.add("swiper-slide");
            swiperWrapper.appendChild(column);
        });

        const swiperContainer = document.createElement("div");
        swiperContainer.classList.add("swiper", "videos-slider-container");

        swiperContainer.appendChild(swiperWrapper);

        const pagination = document.createElement("div");
        const paginationClass = `swiper-pagination-videos-${index}`;
        pagination.classList.add(paginationClass);

        block.innerHTML = "";
        block.appendChild(swiperContainer);
        block.appendChild(pagination);

        new Swiper(swiperContainer, {
            slidesPerView: 1,
            spaceBetween: 24,
            loop: false,
            pagination: {
                el: `.${paginationClass}`,
                clickable: true
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
}
            }
        });
    });
};

function galerySwiper() {
    const videosBlocks = document.querySelectorAll(".wp-block-columns.is-style-galery-slider");

    videosBlocks.forEach((block, index) => {
        const columns = block.querySelectorAll(".wp-block-column");

        const swiperWrapper = document.createElement("div");
        swiperWrapper.classList.add("swiper-wrapper");

        columns.forEach((column) => {
            column.classList.add("swiper-slide");
            swiperWrapper.appendChild(column);
        });

        const swiperContainer = document.createElement("div");
        swiperContainer.classList.add("swiper", "galery-slider-container");

        swiperContainer.appendChild(swiperWrapper);

        const pagination = document.createElement("div");
        const paginationClass = `swiper-pagination-galery-${index}`;
        pagination.classList.add(paginationClass);

        block.innerHTML = "";
        block.appendChild(swiperContainer);
        block.appendChild(pagination);

        new Swiper(swiperContainer, {
            slidesPerView: 2,
            spaceBetween: 8,
            loop: false,
            pagination: {
                el: `.${paginationClass}`,
                clickable: true
            },
            breakpoints: {
                768: {
                    slidesPerView: 5,
                    spaceBetween: 24,
}
            }
        });
    });
};

function photoCtaSwiper() {
    const discographyBlocks = document.querySelectorAll(".wp-block-columns.is-style-galery-photo-cta-slider");

    discographyBlocks.forEach((block, index) => {
        const columns = block.querySelectorAll(".wp-block-column");

        const swiperWrapper = document.createElement("div");
        swiperWrapper.classList.add("swiper-wrapper");

        columns.forEach((column) => {
            column.classList.add("swiper-slide");
            swiperWrapper.appendChild(column);
        });

        const swiperContainer = document.createElement("div");
        swiperContainer.classList.add("swiper", "galery-photo-cta-slider-container");

        swiperContainer.appendChild(swiperWrapper);

        const pagination = document.createElement("div");
        const paginationClass = `swiper-pagination-galery-photo-cta-${index}`;
        pagination.classList.add(paginationClass);

        block.innerHTML = "";
        block.appendChild(swiperContainer);
        block.appendChild(pagination);

        new Swiper(swiperContainer, {
            slidesPerView: 1,
            spaceBetween: 32,
            loop: false,
            freeMode: true,
            mousewheel: {
                enabled: true,
                releaseOnEdges: true,
                sensitivity: 1
            },
            breakpoints: {
                768: {
                    slidesPerView: 4,
}
            }
        });
    });
};

function ageGroupSwiper() {
    const ageInfoSlug = typeof ageInfo !== 'undefined' && ageInfo && typeof ageInfo.slug === 'string'
        ? ageInfo.slug
        : window.location.pathname.replace(/\/$/, '').split('/').pop();
    if (typeof Swiper === 'undefined') {
        return;
    }

    const ageGroupBlocks = document.querySelectorAll("#age-group-slider, .age-group-slider");

    ageGroupBlocks.forEach((block, index) => {
        const columns = block.querySelectorAll(".card");
        if (columns.length === 0) return;

        const swiperWrapper = document.createElement("div");
        swiperWrapper.classList.add("swiper-wrapper");

        columns.forEach((column) => {
            column.classList.add("swiper-slide");
            swiperWrapper.appendChild(column);
        });

        let sliderContainerClass = "age-group-slider-container";
        let sliderControlsClass = "age-group-slider-controls";
        if ('escapadas' === ageInfoSlug){
            sliderContainerClass = "age-group-slider-container-green";
            sliderControlsClass = "age-group-slider-controls-green";
        }
        const swiperContainer = document.createElement("div");
        swiperContainer.classList.add("swiper", sliderContainerClass);
        swiperContainer.appendChild(swiperWrapper);

        const createNavButton = (type) => {
            const button = document.createElement("div");
            button.classList.add(`age-nav-${type}`, `age-nav-${type}-${index}`);

            const svgNS = "http://www.w3.org/2000/svg";
            const svg = document.createElementNS(svgNS, "svg");
            svg.setAttribute("viewBox", "0 0 24 24");
            svg.setAttribute("width", "24");
            svg.setAttribute("height", "24");

            const path = document.createElementNS(svgNS, "path");
            path.setAttribute(
                "d",
                type === "next" ? "M8.12 4.12L16 12l-7.88 7.88" : "M15.88 4.12L8 12l7.88 7.88"
            );
            path.setAttribute("fill", "none");
            path.setAttribute("stroke", "white");
            path.setAttribute("stroke-width", "2");
            path.setAttribute("stroke-linecap", "round");
            path.setAttribute("stroke-linejoin", "round");

            svg.appendChild(path);
            button.appendChild(svg);

            return button;
        };

        const prevButton = createNavButton("prev");
        const nextButton = createNavButton("next");
        const pagination = document.createElement("div");
        pagination.classList.add(`swiper-pagination`, `age-pagination-${index}`);
        swiperContainer.appendChild(pagination);


        const controlsContainer = document.createElement("div");
        controlsContainer.classList.add(sliderControlsClass);
        controlsContainer.appendChild(prevButton);
        controlsContainer.appendChild(nextButton);

        block.innerHTML = "";
        block.appendChild(swiperContainer);
        block.appendChild(controlsContainer);

        let swiper = new Swiper(swiperContainer, {
            slidesPerView: 1,
            spaceBetween: 32,
            loop: false,
            freeMode: true,
            navigation: {
                nextEl: `.age-nav-next-${index}`,
                prevEl: `.age-nav-prev-${index}`,
            },
            pagination: {
                el: `.age-pagination-${index}`,
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 4,
                    pagination: {
                        el: `.age-pagination-${index}`,
                        clickable: false,
                    },
                }
            },
        });

        // Forzar update por si Swiper calcula mal el ancho
        setTimeout(() => swiper.update(), 100);
        window.addEventListener('resize', () => swiper.update());
    });
};

document.addEventListener('DOMContentLoaded', initFrontendScripts);
window.addEventListener('resize', updateHeaderOffsetSpacing);
window.addEventListener('orientationchange', updateHeaderOffsetSpacing);
window.addEventListener('load', updateHeaderOffsetSpacing);
